declare global {
  interface Window {
    __env?: {
      KEYCLOAK_URL?: string;
      GRAFANA_URL?: string;
    };
  }
}

/**
 * Reads a host-specific URL injected at container start (see env-config.js / docker
 * entrypoint), falling back to the build-time environment.*.ts value when unset — lets the
 * same image switch between localhost/UAT/prod without a rebuild.
 */
export function runtimeUrl(key: 'KEYCLOAK_URL' | 'GRAFANA_URL', fallback: string): string {
  return window.__env?.[key]?.trim() || fallback;
}